import { ChangeEventHandler } from 'react'
import { Box, Checkbox, TableCell, TableRow, useTheme } from '@mui/material'

import { useMe } from 'src/hooks'

import { NavButton } from '../nav-button.component'

import { IDraftScanRespDto } from 'src/types'
import { getTableTimestamp } from 'src/common/utils'

import { useStyles } from './styles'
import { TableRelationIcon } from 'src/components/table-relation-icon'
import { TextCell } from '../../scans/scans-table/text-cell.component'

interface IProps {
  item: IDraftScanRespDto
  isItemSelected: (id: string) => boolean
  handleItemCheck: (id: string) => ChangeEventHandler<HTMLInputElement>
  handleInRowClick: () => void
}

export const BodyRow = ({ item, isItemSelected, handleItemCheck, handleInRowClick }: IProps) => {
  const theme = useTheme()
  const classes = useStyles()
  const { data: curUser } = useMe()

  return (
    <TableRow>
      <TableCell align="center">
        <Checkbox
          checked={isItemSelected(item.id)}
          onChange={handleItemCheck(item.id)}
          sx={{ color: theme.palette.custom.grey2 }}
          onClick={handleInRowClick}
        />
      </TableCell>
      <TableCell>{item.batch_id || '-'}</TableCell>
      <TableCell align="center">
        {item.account && (
          <Box>
            <TableRelationIcon
              title={item.account?.account_holder || '-'}
              iconAlt={item.account?.account_holder}
              icon={item.account.image_small || item.account.image}
              size={40}
              cursor="default"
              resetAvatarMargin
            />
            <TextCell withHashSymbol primaryAccent primary={item.account?.account_holder || '-'} />
          </Box>
        )}
      </TableCell>
      <TableCell align="center">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          {item.product && (
            <TableRelationIcon
              iconAlt={item.product.name}
              icon={item.product.image_small || item.product.image}
              size={40}
              cursor="default"
              resetAvatarMargin
              title={'#' + item.product?.code}
            />
          )}
        </Box>
        <TextCell withHashSymbol primaryAccent primary={item.product?.name || '-'} />
      </TableCell>
      <TableCell>
        <div className={classes.iconWrapper}>
          <TextCell
            withHashSymbol
            primaryAccent
            primary={item.step?.name || '-'}
            secondary={item.step?.code}
          />
        </div>
      </TableCell>
      <TableCell align="center" sx={{ fontSize: '10px' }}>
        {getTableTimestamp({ date: item.created_at, timezone: curUser?.timezone })}
      </TableCell>
      <TableCell align="center">
        <NavButton itemId={item.id} />
      </TableCell>
    </TableRow>
  )
}
